import { useBreakpoints } from '@vueuse/core';

export function isMobileView() {
	const breakpoints = {
		mobile: 0,
		desktop: 768,
	};

	const breakpointsList = useBreakpoints(breakpoints);

	const mobileView = !breakpointsList.desktop.value;

	return mobileView;
}

export const randomInt = () => Math.floor(Math.random() * 1000);
